
import { authConstants } from "./constants/authConstants";

const loginRequest = (credentials: any) => ({
  type: authConstants.userLoginRequest, payload: credentials
});

const logoutRequest = () => ({
  type: authConstants.userLogoutRequest,
});

const verifyOptRequest = (credentials:any)=>({
  type:authConstants.userVerifyOtpRequest,
  payload:credentials
});

const verifyLinkRequest = (token:string)=>({
  type:authConstants.verifyInviteRequest,
  payload:token
})

const verifyLinkReset = () => ({
  type: authConstants.verifyInviteReset,
});

const resendInviteRequest = (input:any) =>({
  type:authConstants.userResendInviteRequest,
  payload:input
})

const sendOtpRequest = (payload: any) => ({
  type: authConstants.sendOtpRequest,
  payload
});

const resendOtpRequest = (payload: any) => ({
  type: authConstants.resendOtpRequest,
  payload
});

const sendOtpReset = () => ({
    type: authConstants.sendOtpReset,
});

export const authActions = {
  loginRequest,
  logoutRequest,
  verifyOptRequest,
  verifyLinkRequest,
  verifyLinkReset,
  resendInviteRequest,
  sendOtpRequest,
  resendOtpRequest,
  sendOtpReset
};
